module.exports = __webpack_public_path__ + "img/KW.e9ab2e74.svg";